import React from 'react';
import ModuloTemplate from '../Elements/ModuloTemplate';

const bnrimg = require('../../images/clients.jpg');
const productImg = require('../../images/Proyectos.png');

const ModuleProyects = () => (
    <ModuloTemplate
        moduleKey="proyectos"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ModuleProyects;
